import { NationalLegues } from "../../../apis/types";
import { Colors } from "../../../utils/colors";
import trophy from "../../../assets/tennis_grey_bg.png";
import { TCText } from "../../../components/tcText/TCText";
import { useMemo } from "react";
import { LeagueLevel } from "../../../utils/typeValues";
import { useNavigate } from "react-router-dom";
import { useNationalLeagueStore } from "../../../store/StoreContext";

type props = {
  league: NationalLegues;
};

export const League: React.FC<props> = ({ league }) => {
  const navigate = useNavigate();
  const navtionalLeagueStore = useNationalLeagueStore();

  const startDate = useMemo(() => {
    return league.leagueStartDate.split("T")[0];
  }, [league.leagueStartDate]);
  const endDate = useMemo(() => {
    return league.leagueEndDate.split("T")[0];
  }, [league.leagueEndDate]);

  const level = useMemo(() => {
    return league.level === LeagueLevel.Low
      ? "Low"
      : league.level === LeagueLevel.Intermediate
      ? "Intermediate"
      : "High";
  }, [league.level]);

  return (
    <div
      onClick={() => {
        navtionalLeagueStore.setLeagueId(league.id);
        navigate(`/national-league-matches`);
      }}>
      <div
        style={{
          width: "100%",
          paddingLeft: 10,
          paddingRight: 5,
          paddingTop: 12,
          paddingBottom: 12,
          backgroundColor: Colors.white,
          borderTopRightRadius: 20,
          borderTopLeftRadius: 20,
        }}>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <img src={trophy} alt="trophy" style={{ width: 30, height: 30 }} />
          <TCText
            value={league.leagueName}
            style={{ fontSize: 16, fontWeight: 600 }}
          />
        </div>
        <div
          style={{
            height: 1,
            backgroundColor: Colors.lightGreyBackground,
            flex: 1,
            marginTop: 10,
            marginBottom: 10,
          }}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
          }}>
          <TCText
            value={startDate}
            style={{
              fontSize: 14,
              fontWeight: 700,
              marginTop: 10,
              color: Colors.green,
            }}
          />
          <TCText
            value={"to"}
            style={{
              fontSize: 14,
              fontWeight: 600,
              marginTop: 10,
              color: Colors.black,
            }}
          />
          <TCText
            value={endDate}
            style={{
              fontSize: 14,
              fontWeight: 700,
              marginTop: 10,
              color: "red",
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: 20,
            paddingRight: 10,
          }}>
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}>
              <TCText
                value={"Level: "}
                style={{
                  fontSize: 14,
                  fontWeight: 700,
                  color: Colors.darkBrown,
                  textAlign: "center",
                }}
              />
              <TCText
                value={level}
                style={{
                  fontSize: 14,
                  fontWeight: 600,
                  color: Colors.black,
                  textAlign: "center",
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  marginTop: 10,
                }}>
                <TCText
                  value={"Match Count: "}
                  style={{
                    fontSize: 14,
                    fontWeight: 700,
                    color: Colors.darkBrown,
                    textAlign: "center",
                  }}
                />
                <TCText
                  value={league.matchCount.toString()}
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: Colors.black,
                    textAlign: "center",
                  }}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
            }}>
            <TCText
              value={"Subscription Count: "}
              style={{
                fontSize: 14,
                fontWeight: 700,
                color: Colors.darkBrown,
                textAlign: "center",
              }}
            />
            <TCText
              value={league.subscriptionCount.toString()}
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: Colors.black,
                textAlign: "center",
              }}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          backgroundColor: league.isActive
            ? Colors.darkBrown
            : Colors.lightGreyBackground,
          width: "100%",
          borderRadius: "0 0 16px 16px",
        }}>
        <p
          style={{
            color: league.isActive ? Colors.white : Colors.darkBrown,
            fontSize: 12,
            fontWeight: 600,
            paddingTop: 5,
            paddingBottom: 5,
            paddingLeft: 16,
            paddingRight: 16,
            textAlign: "center",
          }}>
          {league.isActive ? "Active" : "Inactive"}
        </p>
      </div>
    </div>
  );
};
